<template>
    <div class="mt-6 mt-md-5 card cinema-card">
        <div class="row d-md-none">
            <a class="d-block col-4 pr-0 cinema-card-poster" :href="singleUrl">
                <img class="img-fluid" :src="poster" :alt="name">
            </a>

            <div class="col-8 cinema-card-details">
                <h3 class="mb-3 font-weight-semibold cinema-card-title">
                    <a :href="singleUrl">
                        {{ name }}
                    </a>
                </h3>

                <dl v-if="website" class="my-0 font-size-small clearfix cinema-card-details-item">
                    <dt>
                        <i class="mr-3 far fa-fw fa-globe color-black"></i>
                    </dt>
                    <dd>
                        <a :href="website" target="_blank">{{ website }}</a>
                    </dd>
                </dl>

                <dl v-if="phone" class="my-0 font-size-small clearfix cinema-card-details-item">
                    <dt>
                        <i class="mr-3 fas fa-fw fa-phone color-black"></i>
                    </dt>
                    <dd>
                        <a :href="'tel:' + phone">{{ phone }}</a>
                    </dd>
                </dl>

                <dl v-if="fullAddress" class="my-0 font-size-small clearfix cinema-card-details-item">
                    <dt>
                        <i class="mr-3 fas fa-fw fa-map-marker-alt color-black"></i>
                    </dt>
                    <dd>
                        <a :href="'https://maps.google.com/?q=' + name" target="_blank">{{ fullAddress }}</a>
                    </dd>
                </dl>
            </div>
        </div>

        <div class="d-none d-md-block">
            <a class="d-block cinema-card-poster" :href="singleUrl">
                <img class="img-fluid" :src="poster" :alt="name">
            </a>

            <div class="mt-3 pl-3 cinema-card-details">
                <h3 class="mb-3 font-weight-semibold cinema-card-title">
                    <a :href="singleUrl">
                        {{ name }}
                    </a>
                </h3>

                <dl v-if="website" class="my-0 font-size-small clearfix cinema-card-details-item">
                    <dt>
                        <i class="mr-3 far fa-fw fa-globe color-black"></i>
                    </dt>
                    <dd>
                        <a :href="website" target="_blank">{{ website }}</a>
                    </dd>
                </dl>

                <dl v-if="phone" class="my-0 font-size-small clearfix cinema-card-details-item">
                    <dt>
                        <i class="mr-3 fas fa-fw fa-phone color-black"></i>
                    </dt>
                    <dd>
                        <a :href="'tel:' + phone">{{ phone }}</a>
                    </dd>
                </dl>

                <dl v-if="fullAddress" class="my-0 font-size-small clearfix cinema-card-details-item">
                    <dt>
                        <i class="mr-3 fas fa-fw fa-map-marker-alt color-black"></i>
                    </dt>
                    <dd>
                        <a :href="'https://maps.google.com/?q=' + name" target="_blank">{{ fullAddress }}</a>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            poster: {
                type: String,
                required: true,
            },
            name: {
                type: String,
                required: true,
            },
            slug: {
                type: String,
                required: true,
            },
            singleUrl: {
                type: String,
                required: true,
            },
            website: {
                type: String,
            },
            fullAddress: {
                type: String,
            },
            phone: {
                type: String,
            },
        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/cinemas/CinemaCard.vue